import * as React from 'react';
export const cartSvg = React.forwardRef(function cartSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.5 16c.825 0 1.5-.675 1.5-1.5S7.325 13 6.5 13 5 13.675 5 14.5c0 .838.662 1.5 1.5 1.5Zm6 0c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5-1.5.675-1.5 1.5c0 .838.662 1.5 1.5 1.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M0 1.25A.75.75 0 0 1 .75.5h2.396a1.75 1.75 0 0 1 1.728 1.477l.24 1.523h9.459a1.427 1.427 0 0 1 1.394 1.73l-.977 4.498a2.25 2.25 0 0 1-2.2 1.772H6.78a2.25 2.25 0 0 1-2.22-1.9L3.392 2.212A.25.25 0 0 0 3.146 2H.75A.75.75 0 0 1 0 1.25ZM5.351 5l.69 4.367a.75.75 0 0 0 .74.633h6.01a.75.75 0 0 0 .733-.59L14.483 5H5.35Z',
    }),
  );
});
cartSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cart = {
  category: 'icon',
  colorable: true,
  name: 'cart',
  svg: cartSvg,
};
